(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2622],{

/***/ 43894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageCloudinary; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cloudinary_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27410);
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67848);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(370);




function ImageCloudinary(param) {
    var provider_metadata = param.provider_metadata, resizeParameters = param.resizeParameters, className = param.className, alt = param.alt;
    var image = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_1__/* .CloudinaryImage */ .t(provider_metadata.public_id, {
        cloudName: "partager"
    });
    if (resizeParameters) {
        image.resize(resizeParameters);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudinary_react__WEBPACK_IMPORTED_MODULE_2__/* .AdvancedImage */ .pw, {
        cldImg: image,
        alt: alt,
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("w-full h-auto", className)
    });
}


/***/ }),

/***/ 70995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var IsEditionMode = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
/* harmony default export */ __webpack_exports__["Z"] = (IsEditionMode);


/***/ }),

/***/ 99465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AvatarPartager; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61099);
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(boring_avatars__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(370);
/* harmony import */ var _ImageCloudinary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43894);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20493);





var PALETTE = [
    "#CAF729",
    "#79DD7E",
    "#2ECBAA",
    "#21B6B6",
    "#888DDA"
];
var WIDTHS = {
    6: "1.5rem",
    8: "2rem",
    10: "2.5rem",
    20: "5rem",
    36: "9rem"
};
var SIZES = {
    6: "w-6 h-6",
    8: "w-8 h-8",
    10: "w-10 h-10",
    20: "w-20 h-20",
    36: "w-36 h-36"
};
function AvatarPartager(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "marble" : _variant, _size = param.size, size = _size === void 0 ? 10 : _size, _name = param.name, name = _name === void 0 ? "Partager" : _name, _square = param.square, square = _square === void 0 ? false : _square, src = param.src, className = param.className, provider_metadata = param.provider_metadata, resizeParameters = param.resizeParameters;
    var rounded = square ? "rounded" : "rounded-full";
    if (provider_metadata) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SIZES[size], rounded, className, "overflow-hidden"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ImageCloudinary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                provider_metadata: provider_metadata,
                alt: name,
                resizeParameters: resizeParameters,
                className: "h-full w-full min-h-full object-cover"
            })
        });
    }
    if (src) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SIZES[size], rounded, className, "overflow-hidden"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: src,
                alt: name,
                className: "h-full w-full min-h-full object-cover"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SIZES[size], rounded, className, "overflow-hidden"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((boring_avatars__WEBPACK_IMPORTED_MODULE_1___default()), {
            colors: PALETTE,
            variant: variant,
            size: WIDTHS[size],
            name: name || "Partager",
            square: square
        })
    });
}


/***/ }),

/***/ 20493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Image(param) {
    var src = param.src, alt = param.alt, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: src
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: src,
                alt: alt,
                className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full h-auto", className)
            })
        ]
    });
}


/***/ }),

/***/ 84240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Spinner(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "status",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            "aria-hidden": "true",
            className: "w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 ".concat(className),
            viewBox: "0 0 100 101",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                    fill: "currentFill"
                })
            ]
        })
    });
}


/***/ }),

/***/ 74340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L8": function() { return /* binding */ buttonSize; },
/* harmony export */   "ZP": function() { return /* binding */ Button; },
/* harmony export */   "uX": function() { return /* binding */ buttonColor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(370);
/* harmony import */ var _basic_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84240);



var buttonColor = {
    primary: "text-white bg-gray-800 hover:bg-black focus:ring-gray-300 dark:text-gray-900 dark:bg-gray-50 dark:hover:bg-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 ",
    alternative: "text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
    borderless: "text-gray-900 bg-white hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
    danger: "text-white bg-red-700 hover:bg-red-800 focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900",
    link: "underline hover:no-underline active:no-underline focus:no-underline cursor-pointer text-gray-800 underline-offset-2 dark:text-gray-300",
    transparent: "bg-transparent focus:ring-transparent p-0"
};
var buttonSize = {
    "no-size": "p-0 m-0",
    "extra-small": "py-2 px-3 text-xs ",
    small: "py-2 px-3 text-sm ",
    base: "px-2 lg:px-5 py-2 lg:py-2.5 text-sm",
    large: "py-3 px-5 text-base",
    "extra-large": "px-6 py-3.5 text-base "
};
function Button(param) {
    var children = param.children, _color = param.color, color = _color === void 0 ? "primary" : _color, _size = param.size, size = _size === void 0 ? "base" : _size, className = param.className, _type = param.type, type = _type === void 0 ? "button" : _type, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _loadingMessage = param.loadingMessage, loadingMessage = _loadingMessage === void 0 ? "" : _loadingMessage, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? loading : _disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(buttonColor[color], buttonSize[size], "font-bold rounded-lg focus:z-10 focus:ring-2", className, {
            "flex items-center justify-center gap-3": loading
        }),
        type: type,
        onClick: onClick,
        disabled: disabled,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "!w-6 !h-6"
                }),
                loadingMessage
            ]
        }) : children
    });
}


/***/ }),

/***/ 45214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99730);




var states = {
    primary: "bg-gray-50 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ",
    error: ""
};
var errorClass = "bg-red-100 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-red-100 dark:border-red-400";
function TextInput(param) {
    var id = param.id, name = param.name, _type = param.type, type = _type === void 0 ? "text" : _type, _state = param.state, state = _state === void 0 ? "primary" : _state, _errorText = param.errorText, errorText = _errorText === void 0 ? "" : _errorText, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, className = param.className, register = param.register, onChange = param.onChange, placeholder = param.placeholder, min = param.min, max = param.max, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                id: id
            }, onChange && {
                onChange: onChange
            }, register && register(name)), {
                disabled: disabled,
                type: type,
                placeholder: placeholder,
                className: "".concat(states[state], " ").concat(errorText ? errorClass : "", " ").concat(disabled ? "text-gray-500" : "", " shadow-sm border text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:shadow-sm-light ").concat(className)
            }), min && {
                min: min
            }, max && {
                max: max
            }, value && {
                value: value
            })),
            errorText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                variant: "error",
                className: "mt-2 text-sm text-red-600 dark:text-red-500",
                children: errorText
            }) : ""
        ]
    });
}


/***/ }),

/***/ 51859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Heading2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Heading2(param) {
    var variant = param.variant, _level = param.level, level = _level === void 0 ? 2 : _level, className = param.className, children = param.children;
    var variantClass = "font-sans text-lg font-bold text-gray-900 mt-[2em] mb-[1em] dark:text-white";
    if (variant === "frontend") {
        variantClass = "font-sans text-xl lg:text-2xl md:text-3xl font-bold text-gray-900 mt-[2em] mb-[0.5em] md:mb-[1em] dark:text-white";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(variantClass, className),
        "aria-level": level,
        children: children
    });
}


/***/ }),

/***/ 83739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Heading3; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Heading3(param) {
    var children = param.children, className = param.className, _level = param.level, level = _level === void 0 ? 3 : _level, variant = param.variant, id = param.id;
    var variantClass = "font-sans text-sm font-bold text-gray-800 mt-[2em] mb-[1em] dark:text-white";
    if (variant === "frontend") {
        variantClass = "font-sans text-xl lg:text-2xl font-bold text-gray-900 mt-[2em] mb-[1em] dark:text-white";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(variantClass, className),
        "aria-level": level,
        id: id,
        children: children
    });
}


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(370);



function Link(param) {
    var href = param.href, className = param.className, children = param.children, _type = param.type, type = _type === void 0 ? "default" : _type, target = param.target, onClick = param.onClick, rel = param.rel;
    var STYLES = {
        default: "underline hover:no-underline active:no-underline focus:no-underline",
        alternative: "no-underline hover:underline active:underline focus:underline",
        "no-underline": "no-underline hover:no-underline active:no-underline focus:no-underline"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: target,
            onClick: onClick,
            href: href,
            rel: rel,
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STYLES[type], "cursor-pointer text-gray-800 underline-offset-2 dark:text-gray-300", className),
            children: children
        })
    });
}


/***/ }),

/***/ 99730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Paragraph(param) {
    var variant = param.variant, className = param.className, children = param.children;
    var variantClass = "font-sans text-sm font-normal text-gray-700 dark:text-white";
    if (variant === "frontend") {
        variantClass = "font-serif text-lg md:text-xl font-normal text-gray-900 dark:text-white";
    }
    if (variant === "error") {
        variantClass = "font-sans text-sm font-normal text-red-600";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(variantClass, className),
        children: children
    });
}


/***/ }),

/***/ 12400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function Seo(param) {
    var title = param.title, description = param.description, image = param.image, type = param.type, url = param.url, author = param.author, createdAt = param.createdAt, thematic = param.thematic, _isCanonical = param.isCanonical, isCanonical = _isCanonical === void 0 ? false : _isCanonical;
    var fullUrl = "".concat("https://partager.io").concat(url);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@partager.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@partager.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:src",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: author
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: fullUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Partager.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:published_time",
                content: createdAt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:author",
                content: author
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:section",
                content: thematic
            }),
            isCanonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            })
        ]
    });
}


/***/ }),

/***/ 62224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SubscribeToPaidOffer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/OrderContext.tsx
var OrderContext = __webpack_require__(73376);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./components/elements/Button/index.tsx
var Button = __webpack_require__(74340);
// EXTERNAL MODULE: ./components/elements/Heading/Heading3/index.tsx
var Heading3 = __webpack_require__(83739);
// EXTERNAL MODULE: ./components/Tiptap/Tiptap.module.css
var Tiptap_module = __webpack_require__(832);
var Tiptap_module_default = /*#__PURE__*/__webpack_require__.n(Tiptap_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./features/order/index.ts + 3 modules
var order = __webpack_require__(55403);
// EXTERNAL MODULE: ./features/subscriber/index.ts + 2 modules
var subscriber = __webpack_require__(32780);
;// CONCATENATED MODULE: ./components/modules/SubscriberForm/SubscribeToPaidOffer/SubscribeToPaidOffer.service.ts





function isUserPaidSubscribed(publicationId, userToken) {
    return _isUserPaidSubscribed.apply(this, arguments);
}
function _isUserPaidSubscribed() {
    _isUserPaidSubscribed = (0,_async_to_generator/* default */.Z)(function(publicationId, userToken) {
        var ref, subscriptions, foundSubscription;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,subscriber/* getUserSubscriptions */.ec)(userToken)
                    ];
                case 1:
                    ref = _state.sent(), subscriptions = ref.data;
                    foundSubscription = subscriptions.find(function(subscription) {
                        return subscription.publication.id === publicationId;
                    });
                    if (!foundSubscription) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        2,
                        foundSubscription.offerType.name !== "free"
                    ];
            }
        });
    });
    return _isUserPaidSubscribed.apply(this, arguments);
}
function checkPaidRender(publicationId, userToken, setIsSubscribed) {
    return _checkPaidRender.apply(this, arguments);
}
function _checkPaidRender() {
    _checkPaidRender = (0,_async_to_generator/* default */.Z)(function(publicationId, userToken, setIsSubscribed) {
        var isSubscribed;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        isUserPaidSubscribed(publicationId, userToken)
                    ];
                case 1:
                    isSubscribed = _state.sent();
                    setIsSubscribed(isSubscribed);
                    return [
                        2
                    ];
            }
        });
    });
    return _checkPaidRender.apply(this, arguments);
}
function goToPaymentFunnel(_) {
    return _goToPaymentFunnel.apply(this, arguments);
}
function _goToPaymentFunnel() {
    _goToPaymentFunnel = (0,_async_to_generator/* default */.Z)(function(param) {
        var removeOrder, updateOrder, router, publication, session;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    removeOrder = param.removeOrder, updateOrder = param.updateOrder, router = param.router, publication = param.publication, session = param.session;
                    removeOrder();
                    updateOrder({
                        publication: publication,
                        price: null,
                        email: (session === null || session === void 0 ? void 0 : session.user.email) || order/* waitingEmail */.z_,
                        step: 1,
                        onlyPaidOffers: true
                    });
                    return [
                        4,
                        router.push(routes/* default.chooseAPlan.getUrl */.Z.chooseAPlan.getUrl())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _goToPaymentFunnel.apply(this, arguments);
}

;// CONCATENATED MODULE: ./components/modules/SubscriberForm/SubscribeToPaidOffer/index.tsx










function SubscribeToPaidOffer(param) {
    var publication = param.publication, className = param.className, isSubscribeBanner = param.isSubscribeBanner;
    var router = (0,next_router.useRouter)();
    var ref = (0,node_modules_react.useContext)(OrderContext/* OrderContext */.y), updateOrder = ref.updateOrder, removeOrder = ref.removeOrder;
    var ref1 = (0,node_modules_react.useState)(false), isSubscribed = ref1[0], setIsSubscribed = ref1[1];
    var ref2 = (0,react.useSession)(), session = ref2.data;
    (0,node_modules_react.useEffect)(function() {
        if (session) {
            checkPaidRender(publication.id, session.jwt, setIsSubscribed);
        }
    }, [
        publication.id,
        session
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classnames/* default */.Z)("flex flex-col justify-center", {
            "items-center": !isSubscribeBanner
        }),
        children: isSubscribed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Vous \xeates abonn\xe9"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                isSubscribeBanner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading3/* default */.Z, {
                            variant: "frontend",
                            className: "!mt-0",
                            children: publication.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Vous recevez d\xe9j\xe0 les articles gratuits de cette publication."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,classnames/* default */.Z)("flex items-center gap-1", {
                        "flex-col": !isSubscribeBanner
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Pour acc\xe9der aux articles payants"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            size: "no-size",
                            className: (0,classnames/* default */.Z)((Tiptap_module_default()).editorButton, "whitespace-nowrap w-min", {
                                "!py-1": isSubscribeBanner
                            }, className),
                            onClick: function() {
                                return goToPaymentFunnel({
                                    router: router,
                                    publication: publication,
                                    removeOrder: removeOrder,
                                    updateOrder: updateOrder,
                                    session: session
                                });
                            },
                            children: "Abonnez-vous !"
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 65773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SubscriberForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./components/Tiptap/isEditorModeContext.ts
var isEditorModeContext = __webpack_require__(70995);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./features/subscriber/index.ts + 2 modules
var subscriber = __webpack_require__(32780);
// EXTERNAL MODULE: ./lib/feature-flags.ts
var feature_flags = __webpack_require__(4136);
;// CONCATENATED MODULE: ./components/modules/SubscriberForm/SubscriberForm.service.ts




function getSubscriptionFromPublication(publicationId, userToken) {
    return _getSubscriptionFromPublication.apply(this, arguments);
}
function _getSubscriptionFromPublication() {
    _getSubscriptionFromPublication = (0,_async_to_generator/* default */.Z)(function(publicationId, userToken) {
        var ref, subscriptions;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,subscriber/* getUserSubscriptions */.ec)(userToken)
                    ];
                case 1:
                    ref = _state.sent(), subscriptions = ref.data;
                    return [
                        2,
                        subscriptions.find(function(subscription) {
                            return subscription.publication.id === publicationId;
                        })
                    ];
            }
        });
    });
    return _getSubscriptionFromPublication.apply(this, arguments);
}
function isSubscriptionType(subscription, isOfferPaid) {
    return isOfferPaid ? subscription.offerType.name !== "free" : subscription.offerType.name === "free";
}
function getSubscribeFormType(publication, session) {
    return _getSubscribeFormType.apply(this, arguments);
}
function _getSubscribeFormType() {
    _getSubscribeFormType = (0,_async_to_generator/* default */.Z)(function(publication, session) {
        var subscription;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!session) {
                        return [
                            2,
                            "free"
                        ];
                    }
                    return [
                        4,
                        getSubscriptionFromPublication(publication.id, session.jwt)
                    ];
                case 1:
                    subscription = _state.sent();
                    if (!subscription) {
                        return [
                            2,
                            "free"
                        ];
                    }
                    return [
                        4,
                        (0,feature_flags/* isPaidModeAvailable */.AO)(publication)
                    ];
                case 2:
                    if (_state.sent()) {
                        if (isSubscriptionType(subscription, true)) {
                            return [
                                2,
                                "none"
                            ];
                        }
                        if (isSubscriptionType(subscription, false)) {
                            return [
                                2,
                                "paid"
                            ];
                        }
                        return [
                            2,
                            "free"
                        ];
                    }
                    if (isSubscriptionType(subscription, false)) {
                        return [
                            2,
                            "none"
                        ];
                    }
                    return [
                        2,
                        "free"
                    ];
            }
        });
    });
    return _getSubscribeFormType.apply(this, arguments);
}
function checkComponentRender(publication, session, setRenderedComponent) {
    return _checkComponentRender.apply(this, arguments);
}
function _checkComponentRender() {
    _checkComponentRender = (0,_async_to_generator/* default */.Z)(function(publication, session, setRenderedComponent) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSubscribeFormType(publication, session)
                    ];
                case 1:
                    setRenderedComponent.apply(void 0, [
                        _state.sent()
                    ]);
                    return [
                        2
                    ];
            }
        });
    });
    return _checkComponentRender.apply(this, arguments);
}

// EXTERNAL MODULE: ./components/elements/Heading/Heading3/index.tsx
var Heading3 = __webpack_require__(83739);
// EXTERNAL MODULE: ./components/elements/Paragraph/index.tsx
var Paragraph = __webpack_require__(99730);
// EXTERNAL MODULE: ./components/modules/SubscriberFormInput/index.tsx
var SubscriberFormInput = __webpack_require__(54177);
;// CONCATENATED MODULE: ./components/modules/SubscriberForm/SubscribeToFreeOffer/index.tsx





function SubscribeToFreeOffer(param) {
    var publication = param.publication, buttonText = param.buttonText, buttonClassName = param.buttonClassName, className = param.className, _horizontalInput = param.horizontalInput, horizontalInput = _horizontalInput === void 0 ? false : _horizontalInput, goToPaymentFunnel = param.goToPaymentFunnel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classnames/* default */.Z)("flex flex-col w-full", className),
        children: [
            publication.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading3/* default */.Z, {
                variant: "frontend",
                className: "!mt-0",
                children: publication.title
            }),
            publication.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                className: "mb-[1em] break-words whitespace-normal",
                children: publication.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberFormInput/* default */.Z, {
                publication: publication,
                goToPaymentFunnel: goToPaymentFunnel,
                buttonClassName: buttonClassName,
                horizontalInput: horizontalInput,
                buttonText: buttonText,
                className: "justify-start"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/modules/SubscriberForm/SubscribeToPaidOffer/index.tsx + 1 modules
var SubscribeToPaidOffer = __webpack_require__(62224);
;// CONCATENATED MODULE: ./components/modules/SubscriberForm/index.tsx








function SubscriberForm(param) {
    var publication = param.publication, buttonText = param.buttonText, buttonClassName = param.buttonClassName, className = param.className, _horizontalInput = param.horizontalInput, horizontalInput = _horizontalInput === void 0 ? false : _horizontalInput, goToPaymentFunnel = param.goToPaymentFunnel, alreadySubscribeClassName = param.alreadySubscribeClassName, _isSubscribeBanner = param.isSubscribeBanner, isSubscribeBanner = _isSubscribeBanner === void 0 ? false : _isSubscribeBanner;
    var ref = (0,react.useSession)(), session = ref.data;
    var ref1 = (0,node_modules_react.useState)("none"), renderedComponent = ref1[0], setRenderedComponent = ref1[1];
    var isEditionModeValue = (0,node_modules_react.useContext)(isEditorModeContext/* default */.Z);
    (0,node_modules_react.useEffect)(function() {
        if (isEditionModeValue) {
            setRenderedComponent("free");
        } else {
            checkComponentRender(publication, session, setRenderedComponent);
        }
    }, [
        isEditionModeValue,
        publication,
        session
    ]);
    if (renderedComponent === "free") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeToFreeOffer, {
            publication: publication,
            className: (0,classnames/* default */.Z)("pb-6", className),
            buttonText: buttonText,
            buttonClassName: buttonClassName,
            horizontalInput: horizontalInput,
            goToPaymentFunnel: goToPaymentFunnel
        });
    }
    if (renderedComponent === "paid") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeToPaidOffer/* default */.Z, {
            className: (0,classnames/* default */.Z)(className),
            isSubscribeBanner: isSubscribeBanner,
            publication: publication
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (0,classnames/* default */.Z)(alreadySubscribeClassName),
        children: "Vous \xeates abonn\xe9"
    });
}


/***/ }),

/***/ 32068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ps": function() { return /* binding */ submit; },
/* harmony export */   "ci": function() { return /* binding */ subscriberFormSchema; },
/* harmony export */   "hL": function() { return /* binding */ parsePublicationForSubscriberInput; },
/* harmony export */   "zi": function() { return /* binding */ shouldPrefillEmail; }
/* harmony export */ });
/* unused harmony export getUserSubscriptionsWithEmail */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6635);
/* harmony import */ var _features_subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32780);
/* harmony import */ var _lib_feature_flags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4136);
/* harmony import */ var _lib_request__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87888);
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];







var subscriberFormSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("Cette adresse email ne semble pas valide.").required("Veuillez renseigner votre adresse e-mail")
}).required();
function subscribeToPaidOffer(_) {
    return _subscribeToPaidOffer.apply(this, arguments);
}
function _subscribeToPaidOffer() {
    _subscribeToPaidOffer = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var router, removeOrder, updateOrder, publication, email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    router = param.router, removeOrder = param.removeOrder, updateOrder = param.updateOrder, publication = param.publication, email = param.email;
                    removeOrder();
                    updateOrder({
                        publication: publication,
                        price: null,
                        email: email,
                        step: 1,
                        onlyPaidOffers: false
                    });
                    return [
                        4,
                        router.push(_config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].chooseAPlan.getUrl */ .Z.chooseAPlan.getUrl())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _subscribeToPaidOffer.apply(this, arguments);
}
function getUserSubscriptionsWithEmail(email) {
    return _getUserSubscriptionsWithEmail.apply(this, arguments);
}
function _getUserSubscriptionsWithEmail() {
    _getUserSubscriptionsWithEmail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(email) {
        var encryptedEmail, ref, _data, subscriptions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    encryptedEmail = Buffer.from(email).toString("base64");
                    return [
                        4,
                        (0,_lib_request__WEBPACK_IMPORTED_MODULE_4__/* .getAxiosAPI */ .P$)("/subscriptions?email=".concat(encryptedEmail))
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, subscriptions = _data.data;
                    return [
                        2,
                        subscriptions
                    ];
            }
        });
    });
    return _getUserSubscriptionsWithEmail.apply(this, arguments);
}
function getSubscriptionFromPublicationWithEmail(publicationId, email) {
    return _getSubscriptionFromPublicationWithEmail.apply(this, arguments);
}
function _getSubscriptionFromPublicationWithEmail() {
    _getSubscriptionFromPublicationWithEmail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(publicationId, email) {
        var subscriptions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getUserSubscriptionsWithEmail(email)
                    ];
                case 1:
                    subscriptions = _state.sent();
                    return [
                        2,
                        subscriptions.find(function(subscription) {
                            return subscription.publication.id === publicationId;
                        })
                    ];
            }
        });
    });
    return _getSubscriptionFromPublicationWithEmail.apply(this, arguments);
}
function isPaidSubscribed(publicationId, email) {
    return _isPaidSubscribed.apply(this, arguments);
}
function _isPaidSubscribed() {
    _isPaidSubscribed = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(publicationId, email) {
        var subscription;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSubscriptionFromPublicationWithEmail(publicationId, email)
                    ];
                case 1:
                    subscription = _state.sent();
                    if (!subscription) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        2,
                        subscription.offerType.name !== "free"
                    ];
            }
        });
    });
    return _isPaidSubscribed.apply(this, arguments);
}
function isFreeSubscribed(publicationId, email) {
    return _isFreeSubscribed.apply(this, arguments);
}
function _isFreeSubscribed() {
    _isFreeSubscribed = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(publicationId, email) {
        var subscription;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSubscriptionFromPublicationWithEmail(publicationId, email)
                    ];
                case 1:
                    subscription = _state.sent();
                    if (!subscription) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        2,
                        subscription.offerType.name === "free"
                    ];
            }
        });
    });
    return _isFreeSubscribed.apply(this, arguments);
}
function showAlreadySubscribed(setStatus, setError) {
    setError("email", {
        type: "custom",
        message: "Vous \xeates d\xe9j\xe0 inscrit."
    });
    setStatus("initial");
}
function submit(_) {
    return _submit.apply(this, arguments);
}
function _submit() {
    _submit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var data, setStatus, publication, goToPaymentFunnel, removeOrder, updateOrder, router, setError, subscriberListFree, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = param.data, setStatus = param.setStatus, publication = param.publication, goToPaymentFunnel = param.goToPaymentFunnel, removeOrder = param.removeOrder, updateOrder = param.updateOrder, router = param.router, setError = param.setError;
                    setStatus("loading");
                    subscriberListFree = publication.subscriberLists.find(function(subscriberList) {
                        return subscriberList.enable && subscriberList.offerType.name === "free";
                    });
                    if (!subscriberListFree) {
                        return [
                            2
                        ];
                    }
                    _tmp = goToPaymentFunnel;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,_lib_feature_flags__WEBPACK_IMPORTED_MODULE_3__/* .isPaidModeAvailable */ .AO)(publication)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!_tmp) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        isPaidSubscribed(publication.id, data.email)
                    ];
                case 3:
                    if (!_state.sent()) return [
                        3,
                        4
                    ];
                    showAlreadySubscribed(setStatus, setError);
                    return [
                        3,
                        8
                    ];
                case 4:
                    _state.trys.push([
                        4,
                        ,
                        6,
                        8
                    ]);
                    return [
                        4,
                        (0,_features_subscriber__WEBPACK_IMPORTED_MODULE_2__/* .postSubscribe */ .Lb)(data.email, publication, subscriberListFree)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        subscribeToPaidOffer({
                            router: router,
                            removeOrder: removeOrder,
                            updateOrder: updateOrder,
                            publication: publication,
                            email: data.email
                        })
                    ];
                case 7:
                    _state.sent();
                    return [
                        7
                    ];
                case 8:
                    return [
                        3,
                        13
                    ];
                case 9:
                    return [
                        4,
                        isFreeSubscribed(publication.id, data.email)
                    ];
                case 10:
                    if (!_state.sent()) return [
                        3,
                        11
                    ];
                    showAlreadySubscribed(setStatus, setError);
                    return [
                        3,
                        13
                    ];
                case 11:
                    return [
                        4,
                        (0,_features_subscriber__WEBPACK_IMPORTED_MODULE_2__/* .postSubscribe */ .Lb)(data.email, publication, subscriberListFree)
                    ];
                case 12:
                    _state.sent();
                    setStatus("success");
                    _state.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return _submit.apply(this, arguments);
}
function parsePublicationForSubscriberInput(publicationString) {
    return JSON.parse(publicationString);
}
function shouldPrefillEmail(isEditionModeValue, session) {
    return !isEditionModeValue && !!(session === null || session === void 0 ? void 0 : session.user);
}


/***/ }),

/***/ 54177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SubscribeToFreeOfferInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47533);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87536);
/* harmony import */ var _context_OrderContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73376);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(370);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74340);
/* harmony import */ var _elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45214);
/* harmony import */ var _elements_Paragraph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99730);
/* harmony import */ var _Tiptap_isEditorModeContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70995);
/* harmony import */ var _SubscriberFormInput_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32068);













function SubscribeToFreeOfferInput(param) {
    var publication = param.publication, _goToPaymentFunnel = param.goToPaymentFunnel, goToPaymentFunnel = _goToPaymentFunnel === void 0 ? true : _goToPaymentFunnel, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "S'abonner" : _buttonText, buttonClassName = param.buttonClassName, horizontalInput = param.horizontalInput, children = param.children, className = param.className;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("initial"), status = ref2[0], setStatus = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_context_OrderContext__WEBPACK_IMPORTED_MODULE_4__/* .OrderContext */ .y), updateOrder = ref3.updateOrder, removeOrder = ref3.removeOrder;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref4 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(), session = ref4.data;
    var isEditionModeValue = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_Tiptap_isEditorModeContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
    var ref5 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_11__/* .yupResolver */ .X)(_SubscriberFormInput_service__WEBPACK_IMPORTED_MODULE_9__/* .subscriberFormSchema */ .ci),
        defaultValues: {
            email: ""
        }
    }), register = ref5.register, handleSubmit = ref5.handleSubmit, errors = ref5.formState.errors, setError = ref5.setError, setValue = ref5.setValue;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if ((0,_SubscriberFormInput_service__WEBPACK_IMPORTED_MODULE_9__/* .shouldPrefillEmail */ .zi)(isEditionModeValue, session)) {
            setValue("email", session.user.email);
        }
        return function() {
            return setValue("email", "");
        };
    }, [
        isEditionModeValue,
        session,
        setValue
    ]);
    var ref6;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: status === "success" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "mt-6",
            children: "Votre inscription a bien \xe9t\xe9 prise en compte."
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("w-full flex items-center gap-5", {
                        "flex-wrap": !horizontalInput
                    }, className),
                    onSubmit: handleSubmit(function(data) {
                        return (0,_SubscriberFormInput_service__WEBPACK_IMPORTED_MODULE_9__/* .submit */ .Ps)({
                            data: data,
                            setStatus: setStatus,
                            publication: publication,
                            goToPaymentFunnel: goToPaymentFunnel,
                            removeOrder: removeOrder,
                            updateOrder: updateOrder,
                            router: router,
                            setError: setError
                        });
                    }),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            name: "email",
                            type: "email",
                            register: register,
                            disabled: (0,_SubscriberFormInput_service__WEBPACK_IMPORTED_MODULE_9__/* .shouldPrefillEmail */ .zi)(isEditionModeValue, session),
                            placeholder: "Votre e-mail",
                            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("bg-white w-full font-sans"),
                            "aria-label": "E-mail"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(buttonClassName),
                            type: "submit",
                            loading: status === "loading",
                            children: buttonText
                        }),
                        children
                    ]
                }),
                (((ref = errors.email) === null || ref === void 0 ? void 0 : ref.message) || status === "error") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    variant: "error",
                    className: "mt-5",
                    children: (ref6 = (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref6 !== void 0 ? ref6 : "Une erreur est survenue. Veuillez r\xe9essayer plus tard."
                })
            ]
        })
    });
}


/***/ }),

/***/ 32780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hf": function() { return /* reexport */ SubscribeStatus; },
  "h9": function() { return /* reexport */ confirmSubscription; },
  "Gr": function() { return /* reexport */ getPublicationSubscribers; },
  "ec": function() { return /* reexport */ getUserSubscriptions; },
  "Lb": function() { return /* reexport */ postSubscribe; },
  "r1": function() { return /* reexport */ unsubscribe; }
});

// UNUSED EXPORTS: getPublicationTotalSubscribers

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./lib/request.ts
var request = __webpack_require__(87888);
;// CONCATENATED MODULE: ./features/subscriber/subscriber.service.ts



var urlPlural = "/subscribers";
function confirmSubscription(hashedEmail, externalId) {
    return _confirmSubscription.apply(this, arguments);
}
function _confirmSubscription() {
    _confirmSubscription = (0,src_async_to_generator/* default */.Z)(function(hashedEmail, externalId) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* putAxiosAPI */.n9)(urlPlural, {
                            list: externalId,
                            token: hashedEmail
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _confirmSubscription.apply(this, arguments);
}
function postSubscribe(email, publication, subscriberList) {
    return _postSubscribe.apply(this, arguments);
}
function _postSubscribe() {
    _postSubscribe = (0,src_async_to_generator/* default */.Z)(function(email, publication, subscriberList) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)(urlPlural, {
                            email: email,
                            publication: publication,
                            subscriberList: subscriberList
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _postSubscribe.apply(this, arguments);
}
function getUserSubscriptions(userToken) {
    return _getUserSubscriptions.apply(this, arguments);
}
function _getUserSubscriptions() {
    _getUserSubscriptions = (0,src_async_to_generator/* default */.Z)(function(userToken) {
        var start, limit, path, query, data, subscriptions;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    start = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0, limit = _arguments.length > 2 ? _arguments[2] : void 0;
                    path = "/subscriptions";
                    query = limit ? "?start=".concat(start, "&limit=").concat(limit) : "";
                    return [
                        4,
                        (0,request/* getAxiosAPI */.P$)("".concat(path).concat(query), userToken)
                    ];
                case 1:
                    data = _state.sent().data;
                    subscriptions = data.data.filter(function(subscription) {
                        var ref;
                        return (ref = subscription.publication) === null || ref === void 0 ? void 0 : ref.user;
                    });
                    return [
                        2,
                        {
                            meta: data.meta,
                            data: subscriptions
                        }
                    ];
            }
        });
    });
    return _getUserSubscriptions.apply(this, arguments);
}
function unsubscribe(email, subscriberListExternalId) {
    return _unsubscribe.apply(this, arguments);
}
function _unsubscribe() {
    _unsubscribe = (0,src_async_to_generator/* default */.Z)(function(email, subscriberListExternalId) {
        var type;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    type = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "free";
                    return [
                        4,
                        (0,request/* putAxiosAPI */.n9)("/unsubscribe", {
                            email: email,
                            list: subscriberListExternalId,
                            type: type
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _unsubscribe.apply(this, arguments);
}
function getPublicationTotalSubscribers(publicationId, userToken) {
    return _getPublicationTotalSubscribers.apply(this, arguments);
}
function _getPublicationTotalSubscribers() {
    _getPublicationTotalSubscribers = _async_to_generator(function(publicationId, userToken) {
        var response;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getAxiosAPI("/publication/total-subscribers/".concat(publicationId, "?type=complex"), userToken)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _getPublicationTotalSubscribers.apply(this, arguments);
}
// TODO check if it's possible to rework this round only using queryString or at least use a page /pageSize pagination
function getPublicationSubscribers(publicationId, start, limit, userToken) {
    return _getPublicationSubscribers.apply(this, arguments);
}
function _getPublicationSubscribers() {
    _getPublicationSubscribers = (0,src_async_to_generator/* default */.Z)(function(publicationId, start, limit, userToken) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* getAxiosAPI */.P$)("/publication/".concat(publicationId, "/subscribers?start=").concat(start, "&limit=").concat(limit), userToken)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _getPublicationSubscribers.apply(this, arguments);
}

;// CONCATENATED MODULE: ./features/subscriber/subscriber.interface.ts
var SubscribeStatus;
(function(SubscribeStatus) {
    SubscribeStatus["ok"] = "En cours";
    SubscribeStatus["pendingUnsubscription"] = "En cours de r\xe9siliation";
})(SubscribeStatus || (SubscribeStatus = {}));

;// CONCATENATED MODULE: ./features/subscriber/index.ts




/***/ }),

/***/ 4136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ isPaidModeAvailable; }
/* harmony export */ });
/* unused harmony exports default, getTestBypassFeatureFlagPaidModeByPublicationId */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87888);



function getFeatureFlagValue(name) {
    return _getFeatureFlagValue.apply(this, arguments);
}
function _getFeatureFlagValue() {
    _getFeatureFlagValue = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(name) {
        var value, ref, featureFlags, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    value = false;
                    return [
                        4,
                        (0,_request__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosAPI */ .P$)("/feature-flags?filters[name][$eq]=".concat(name))
                    ];
                case 1:
                    ref = _state.sent(), featureFlags = ref.data;
                    if (featureFlags.data.length) {
                        ;
                        value = (ref1 = featureFlags.data[0]) === null || ref1 === void 0 ? void 0 : ref1.enabled;
                    }
                    return [
                        2,
                        value
                    ];
            }
        });
    });
    return _getFeatureFlagValue.apply(this, arguments);
}
function getTestBypassFeatureFlagPaidModeByPublicationId(id) {
    return _getTestBypassFeatureFlagPaidModeByPublicationId.apply(this, arguments);
}
function _getTestBypassFeatureFlagPaidModeByPublicationId() {
    _getTestBypassFeatureFlagPaidModeByPublicationId = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var response, publicationId;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_request__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosAPI */ .P$)("/test-bypass-feature-flag-paid-mode")
                    ];
                case 1:
                    response = _state.sent();
                    publicationId = response.data.data.publicationId;
                    return [
                        2,
                        publicationId === id
                    ];
            }
        });
    });
    return _getTestBypassFeatureFlagPaidModeByPublicationId.apply(this, arguments);
}
function isPaidModeAvailable(publication) {
    return _isPaidModeAvailable.apply(this, arguments);
}
function _isPaidModeAvailable() {
    _isPaidModeAvailable = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(publication) {
        var isPublicationBypass, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getTestBypassFeatureFlagPaidModeByPublicationId(publication.id)
                    ];
                case 1:
                    isPublicationBypass = _state.sent();
                    if (isPublicationBypass) {
                        return [
                            2,
                            true
                        ];
                    }
                    _tmp = publication.isPaid;
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getFeatureFlagValue("NEXT_PUBLIC_PAID_MODE_ENABLED")
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return _isPaidModeAvailable.apply(this, arguments);
}


/***/ }),

/***/ 832:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Tiptap_hidden__FNfSk","ProseMirror":"Tiptap_ProseMirror__svmPJ","editorButton":"Tiptap_editorButton__HE1cA","editorSubscribeButton":"Tiptap_editorSubscribeButton__u_Wsg"};

/***/ })

}]);